import { map } from "lodash";
import { useTranslation } from "react-i18next";
import type { DailyReport } from "@/helpers/daily-report";
import { AmountRow, euros, Section } from "./layout";

const Summary = ({ report }: { report: DailyReport }) => {
	const { t } = useTranslation();

	return (
		<div className="grid grid-cols-2 gap-10 print:gap-6 print:text-sm">
			<Section title={t("dailyReport.takings")}>
				<div className="flex flex-col gap-1">
					<AmountRow
						label={t("dailyReport.salesAmount", { count: report.salesCount })}
						amountCents={report.salesAmountCents}
					/>
					<AmountRow
						label={t("dailyReport.refunds", { count: report.refundsCount })}
						amountCents={report.refundsAmountCents}
					/>
					<AmountRow
						isTotal
						label={t("dailyReport.total")}
						amountCents={report.totalAmountCents}
					/>
				</div>
				<div className="flex flex-col gap-1 text-small">
					<div className="flex justify-between">
						<p>{t("dailyReport.itemsSold")}</p>
						<p>{report.itemsSold}</p>
					</div>
					{report.itemsRefunded > 0 && (
						<div className="flex justify-between">
							<p>{t("dailyReport.itemsRefunded")}</p>
							<p>{report.itemsRefunded}</p>
						</div>
					)}
					<div className="flex justify-between">
						<p>{t("dailyReport.averageBasket")}</p>
						<p>{euros(report.averageBasketCents)}</p>
					</div>
				</div>
			</Section>

			<Section title={t("dailyReport.payments")}>
				<div className="flex flex-col gap-1">
					{map(report.payments, (payment) => (
						<AmountRow
							key={payment.id}
							label={payment.name ?? t("dailyReport.unknownPaymentType")}
							detail={
								payment.count > 0
									? t("dailyReport.paymentCount", { count: payment.count })
									: undefined
							}
							amountCents={payment.amountCents}
						/>
					))}
					<AmountRow
						isTotal
						label={t("dailyReport.paymentsTotal")}
						amountCents={report.paymentsAmountCents}
					/>
				</div>
				{report.unsettledAmountCents !== 0 && (
					<p className="text-red-500 text-sm">
						{t("dailyReport.unsettled", {
							amount: euros(report.unsettledAmountCents),
						})}
					</p>
				)}
			</Section>
		</div>
	);
};

export default Summary;
